// Style
import style from "./post-loading.module.scss";
import "react-loading-skeleton/dist/skeleton.css";

// Components
import Skeleton from "react-loading-skeleton";

export default function PostLoading({ displayType }) {
  return (
    <div className={style.postCard}>
      {/* {displayType == "list" && <li>{post.title}</li>} */}
      {/* {getCard(displayType)} */}

      <div className={style.postImg}>
        <Skeleton height={"6rem"} />
      </div>

      <h2>
        <Skeleton />
      </h2>
      <Skeleton count={3} />
    </div>
  );
}
